"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatepickerLang = exports.DATE = void 0;
const vue_1 = __importDefault(require("vue"));
const z = __importStar(require("zod"));
const types_1 = require("./types");
const cell_editor_1 = require("./cell-editor");
const cell_formatter_1 = require("./cell-formatter");
const lang_hu = require('vue2-datepicker/locale/es/hu').default;
const lang_en = require('vue2-datepicker/locale/es/en').default;
const DATE_FORMATTER_CONFIG = types_1.BASE_CONFIG.extend({});
const DATE_EDITOR_CONFIG = types_1.BASE_CONFIG.extend({
    autocomplete: z
        .string()
        .optional()
        .default('off'),
    placeholder: z.string().optional()
});
exports.DATE = {
    name: 'date',
    formatter: {
        schema: DATE_FORMATTER_CONFIG,
        createComponent(config) {
            return {
                minWidth: 110,
                component: {
                    name: 'DateFormatter',
                    mixins: [cell_formatter_1.CellFormatter],
                    ...vue_1.default.compile('<span class="text-nowrap">{{ value|date }}</span>')
                }
            };
        }
    },
    editor: {
        schema: DATE_EDITOR_CONFIG,
        createComponent(config) {
            return {
                minWidth: 110,
                component: {
                    name: 'DateEditor',
                    mixins: [cell_editor_1.CellEditor],
                    ...vue_1.default.compile(`<DatePicker
              input-class="form-control form-control-sm"
              v-model="currentValue"
              v-bind="bindings"
              :autofocus="autofocus"
              :clearable="!col.required"
              :disabled="isDisabled"
              :id="col.field"
              :name="col.name"
              :form="formId"
              :tabindex="col.effectiveTabindex"
              :size="col.size"
              :state=validationState
              @change="onChange($event)"
            ></DatePicker>`),
                    data() {
                        return {
                            bindings: {
                                autocomplete: config.autocomplete,
                                placeholder: config.placeholder,
                                format: 'YYYY.MM.DD',
                                type: 'date',
                                valueType: 'YYYY-MM-DD',
                                lang: getDatepickerLang(config.lang)
                            }
                        };
                    }
                }
            };
        }
    }
};
function getDatepickerLang(lc) {
    if (lc === 'hu') {
        return lang_hu;
    }
    return lang_en;
}
exports.getDatepickerLang = getDatepickerLang;
//# sourceMappingURL=date.js.map